/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-unresolved */
import CustomCheckBox from "src/shared/CustomCheckBox";
import { useFormik } from "formik";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useAppSelector } from "../../../../../utils/hooks/useAppSelector";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

interface AddressFieldSchema {
  label: string;
  visible: boolean;
  defaultValue: string;
  isCheckbox?: never;
}

interface CheckboxFieldSchema {
  label: string;
  visible: boolean;
  name: string;
  isCheckbox: true;
  defaultValue?: never;
}

type BankDetailsSchema = {
  [key: string]: AddressFieldSchema | CheckboxFieldSchema;
};

function BankDetails() {
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const bankDetailsSchema: BankDetailsSchema = mefSchema?.bankDetailsSchema || {};
  const jointLifeDetails = useAppSelector((state) => state.jointLifeAddendum);
  const leadDetails = useAppSelector((state) => state?.common?.leadDetails);
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: {
      jointCoBorrowerFlag: leadDetails.jointCoBorrowerFlag || false,
      jointGuarantorFlag: leadDetails.jointGuarantorFlag || false,
      jointPrimaryBorrowerFlag: leadDetails.jointPrimaryBorrowerFlag || false,
      jointHousewifeFlag: leadDetails.jointHousewifeFlag || false
    },
    onSubmit: () => {}
  });

  const location = useLocation();
  const [isReviewDetailsPage] = useState(location.pathname.includes("form-details"));

  const renderAddressField = (fieldKey: string, config: AddressFieldSchema) => {
    const value =
      jointLifeDetails?.address?.[fieldKey as keyof typeof jointLifeDetails.address] ||
      config.defaultValue;
    return (
      <div className="col-span-1" key={fieldKey}>
        <CustomLabel>{config.label}</CustomLabel>
        <CustomReviewField>{value}</CustomReviewField>
      </div>
    );
  };

  const renderCheckboxField = (config: CheckboxFieldSchema) => {
    const checked = isReviewDetailsPage
      ? jointLifeDetails?.[config.name as keyof typeof jointLifeDetails] || false
      : leadDetails?.[config.name as keyof typeof leadDetails] || false;

    return (
      <div className="col-span-1" key={config.name}>
        <CustomCheckBox
          isReview
          label={config.label}
          name={config.name}
          handleBlur={formik.handleBlur}
          setFieldValue={formik.setFieldValue}
          checked={checked}
        />
      </div>
    );
  };

  return (
    <>
      <div>
        <div className="flex justify-start mt-10">
          <p className="text-base font-bold">Secondary Details</p>
        </div>
        <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 md:gap-x-28 gap-x-3 mt-6 max-sm:ml-4">
          {Object.entries(bankDetailsSchema)
            .filter(([_, config]) => !("isCheckbox" in config) && config.visible)
            .map(([fieldKey, config]) =>
              renderAddressField(fieldKey, config as AddressFieldSchema)
            )}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 max-w-[500px] my-5 sm:my-8">
        {Object.entries(bankDetailsSchema)
          .filter(([_, config]) => "isCheckbox" in config && config.visible)
          .map(([_, config]) => renderCheckboxField(config as CheckboxFieldSchema))}
      </div>
    </>
  );
}
export default BankDetails;
